import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBullhorn,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CommercialVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Commercial Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Business</Subheading>}
        heading={
          <Heading>
            Commercial <span tw="text-primary-500">Video Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in commercial video production in
            **Bur Dubai**, creating high-impact, professional videos that
            elevate your brand and drive business growth through compelling
            storytelling.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1567593810070-7a3d471af022?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional commercial filming
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2672&q=80", // Business video production
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial-quality filming
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Commercial"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Commercial Video Production"
        description="We deliver commercial videos that captivate and convert."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Impactful Messaging",
            description:
              "Videos crafted to resonate with your target audience.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "Professional-grade visuals to enhance your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery for your marketing campaigns.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Videos tailored for TV, web, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Businesses",
            description: "Bur Dubai’s go-to for commercial videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Tailored Solutions",
            description: "Custom videos for ads, products, or services.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Commercial Video Process"
        description={
          <Description>
            We create powerful commercial videos with a refined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your brand and campaign goals.</li>
              <li>
                Storyboarding: Develop a compelling, sales-driven narrative.
              </li>
              <li>
                Filming: Capture stunning visuals with top-tier equipment.
              </li>
              <li>Editing: Polish with effects, branding, and sound design.</li>
              <li>Delivery: Provide ready-to-air commercial videos.</li>
              <li>Support: Offer ongoing campaign support and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039542-a4622982ad53?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial storyboarding
          "https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Commercial Video Wins in Bur Dubai"
        description="Our commercial videos have driven business success."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Increased Sales",
            description: "Boosted conversions with targeted ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "93% satisfaction from Bur Dubai businesses.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Enhanced reach with compelling commercials.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Commercial Success?</Subheading>}
        heading="Commercial Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert commercial video production
            in Bur Dubai. Get professional, high-impact videos to grow your
            business—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577017040065-650ee4d43339?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai business district
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial filming equipment
          "https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional production team
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
